import { Routes } from '../../../app/routes';

const REDIRECT_AFTER_LOGIN_STORAGE_KEY = 'redirectAfterLoginPath';

interface RouteLocation {
  pathname: string;
  search: string;
  hash: string;
}

const getRedirectAfterLoginPath = ({ pathname, search, hash }: RouteLocation): string => {
  const searchParams = new URLSearchParams(search);
  searchParams.delete('domain');
  const redirectSearch = searchParams.toString();

  return `${pathname}${redirectSearch ? `?${redirectSearch}` : ''}${hash}`;
};

export const setRedirectAfterLoginPath = (location: RouteLocation): void => {
  const redirectPath = getRedirectAfterLoginPath(location);

  if (
    redirectPath &&
    redirectPath !== Routes.Login &&
    redirectPath !== Routes.Logout &&
    redirectPath !== Routes.OauthCallback
  ) {
    sessionStorage.setItem(REDIRECT_AFTER_LOGIN_STORAGE_KEY, redirectPath);
  }
};

export const consumeRedirectAfterLoginPath = (): string | null => {
  const redirectPath = sessionStorage.getItem(REDIRECT_AFTER_LOGIN_STORAGE_KEY);
  sessionStorage.removeItem(REDIRECT_AFTER_LOGIN_STORAGE_KEY);

  if (!redirectPath || !redirectPath.startsWith('/') || redirectPath.startsWith('//')) {
    return null;
  }

  if (
    redirectPath.startsWith(Routes.Login) ||
    redirectPath.startsWith(Routes.Logout) ||
    redirectPath.startsWith(Routes.OauthCallback)
  ) {
    return null;
  }

  return redirectPath;
};

export { REDIRECT_AFTER_LOGIN_STORAGE_KEY };
